import { inject, injectable } from '@wix/typesafe-inversify';
import { getWidgetStructureByAppData } from '@wix/blocks-widget-services/editor';
import type { EditorSDK } from '@wix/editor-platform-sdk-types';
import { Services } from '../../ioc/services';
import type { IMasterStructureFetcher } from './IMasterStructureFetcher';
import type { ComponentRef } from '@wix/editor-platform-sdk-types/dist/types/common';
import type { CompStructure } from '@wix/document-services-types';

@injectable()
export class MasterStructureFetcher implements IMasterStructureFetcher {
  constructor(@inject(Services.EditorSDK) private editorSDK: EditorSDK) {}

  cache: Record<string, CompStructure> = {};

  purgeCache() {
    this.cache = {};
  }

  async fetchMasterStructure(widgetRef: ComponentRef) {
    const editorSDK = this.editorSDK;
    const compData: any = await editorSDK.components.data.get('token', {
      componentRef: widgetRef,
    });
    const appDefinitionId = compData.applicationId || compData.appDefinitionId;
    const appData: any = await editorSDK.tpa.app.getDataByAppDefId(
      'token',
      appDefinitionId,
    );
    const settings =
      typeof compData.settings === 'string'
        ? JSON.parse(compData.settings)
        : compData.settings || {};
    const widgetId = settings.type;
    if (!this.cache[widgetId]) {
      this.cache[widgetId] = await getWidgetStructureByAppData(
        appData,
        widgetId,
        undefined,
      );
    }
    return this.cache[widgetId];
  }
}
